import React from 'react';

const ContactPage = () => {
  return <div>About Page</div>;
};

export default ContactPage;
